import {
  DataGridPremium,
  DataGridPremiumProps,
} from '@mui/x-data-grid-premium';

import { useDataGridGroupStyling } from '~/components/SolaForceDataGrid/useDataGridGroupStyling';

export const SolaForceDataGrid = (props: DataGridPremiumProps) => {
  const { sx, columns, columnGroupingModel, ...passThroughProps } = props;

  const processedProps = useDataGridGroupStyling({
    sx,
    columnGroupingModel,
    columns: [...columns],
  });

  const dataGridProps = {
    ...processedProps,
    ...passThroughProps,
  };

  const { slotProps } = dataGridProps;

  return (
    <DataGridPremium
      {...dataGridProps}
      slotProps={
        slotProps
          ? slotProps
          : {
              columnMenu: {
                slots: {
                  columnMenuPinningItem: null,
                  columnMenuAggregationItem: null,
                  columnMenuGroupingItem: null,
                },
              },
            }
      }
    />
  );
};
